module.exports = __webpack_public_path__ + "static/media/collaborate.7fce6aa4.svg";